import { render, staticRenderFns } from "./KnowUs.vue?vue&type=template&id=168cfff0&"
import script from "./KnowUs.vue?vue&type=script&lang=js&"
export * from "./KnowUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports